import {request} from './base'

export default {
    queryPage(data) {
        return request('/order/queryPage', data, 'get')
    },
}
